/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_DescriptionInputs */

const en_profile_description = /** @type {(inputs: Profile_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update your display name and profile photo.`)
};

const pt_br2_profile_description = /** @type {(inputs: Profile_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualize seu nome de exibição e sua foto do perfil.`)
};

/**
* | output |
* | --- |
* | "Update your display name and profile photo." |
*
* @param {Profile_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const profile_description = /** @type {((inputs?: Profile_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profile_description(inputs)
	return pt_br2_profile_description(inputs)
});